// 9fbef606107a605d69c0edbcd8029e5d
import { formValueSelector } from 'redux-form';
import { createSelector } from 'reselect';
import {
  getDynamicLabelValues,
  getLabelFromCopyOrFromTranslation,
  getLabelWithDefaultValue,
} from '@tcp/core/src/utils/labels/labelUtilty';
import { GlobalRegistrationLabels } from '../../../../../utils/labels/globalRegistrations.labels';

export const getLoadingState = (state) => {
  return state?.CreateAccountReducer?.get('isLoading');
};

export const getIsFromCreateAccountFlow = (state) => {
  return state?.CreateAccountReducer?.get('isFromCreateAccountFlow');
};

export const getIsShowOTPScreen = (state) => {
  return state?.CreateAccountReducer?.get('isOtpScreen');
};

export const getShowVerificationError = (state) => {
  return state?.CreateAccountReducer?.get('showVerificationError');
};

export const getShowBriteError = (state) => {
  return state?.CreateAccountReducer?.get('showBriteError');
};

export const getBriteErrorMessage = (state) => {
  return state?.CreateAccountReducer?.get('briteErrorMessage');
};

export const getIAgree = (state) => {
  const selector = formValueSelector('CreateAccountForm');
  return selector(state, 'iAgree');
};

export const getIAgreePolicy = (state) => {
  const selector = formValueSelector('CreateAccountForm');
  return selector(state, 'iAgreePolicy');
};
export const getEmailSubscription = (state) => {
  const selector = formValueSelector('CreateAccountForm');
  return selector(state, 'emailSubscription');
};
export const getHideShowPwd = (state) => {
  const selector = formValueSelector('CreateAccountForm');
  return selector(state, 'hideShowPwd');
};

export const getConfirmHideShowPwd = (state) => {
  const selector = formValueSelector('CreateAccountForm');
  return selector(state, 'confirmHideShowPwd');
};

export const getError = (state) => {
  return state?.CreateAccountReducer?.get('error');
};

export const getErrorCode = (state) => {
  const error = state?.CreateAccountReducer?.get('error');
  return error && error.get('errorCode');
};

export const getErrorMessage = createSelector([getError], (error) => {
  const errorCode = error && error.get('errorCode');
  const emailValue =
    error && error.getIn(['errorResponse', 'errors', '0', 'errorParameters', 'email']);

  const dynamicAccountLabels = getDynamicLabelValues('dynamic.account_d');
  const registrationLabels = getLabelFromCopyOrFromTranslation(
    'global.registration',
    GlobalRegistrationLabels
  );
  const createAccountLabels = {
    ...registrationLabels,
    lbl_createAccount_error__ERR_LOGONID_ALREDY_EXIST: getLabelWithDefaultValue(
      dynamicAccountLabels,
      'lbl_createAccount_error__ERR_LOGONID_ALREDY_EXIST'
    ),
    'lbl_createAccount_error_.2210': getLabelWithDefaultValue(
      dynamicAccountLabels,
      'lbl_createAccount_error_.2210'
    ),
    'lbl_createAccount_error_.2030': getLabelWithDefaultValue(
      dynamicAccountLabels,
      'lbl_createAccount_error_.2030'
    ),
    lbl_createAccount_error__ERR_AUTHENTICATION_SPECIALCHAR_MINIMUMLENGTH_PASSWORD:
      getLabelWithDefaultValue(
        dynamicAccountLabels,
        'lbl_createAccount_error__ERR_AUTHENTICATION_SPECIALCHAR_MINIMUMLENGTH_PASSWORD'
      ),
    lbl_createAccount_error_USID_UNAUTHORIZED: getLabelWithDefaultValue(
      dynamicAccountLabels,
      'lbl_createAccount_error_USID_UNAUTHORIZED'
    ),
    lbl_createAccount_error_ACCOUNT_VERIFY_OTP_COUNT_EXCEEDED: getLabelWithDefaultValue(
      dynamicAccountLabels,
      'lbl_createAccount_error_ACCOUNT_VERIFY_OTP_COUNT_EXCEEDED'
    ),
    lbl_createAccount_error_ACCOUNT_CREATE_OTP_COUNT_ERROR: getLabelWithDefaultValue(
      dynamicAccountLabels,
      'lbl_createAccount_error_ACCOUNT_CREATE_OTP_COUNT_ERROR'
    ),
  };

  if (errorCode && createAccountLabels[`lbl_createAccount_error_${errorCode}`]) {
    if (errorCode === '_ERR_ACCOUNT_EXISTS_IN_SESSION' && emailValue) {
      return createAccountLabels?.lbl_createAccount_error__ERR_ACCOUNT_EXISTS_IN_SESSION.replace(
        '#emailValue#',
        emailValue
      );
    }
    return createAccountLabels[`lbl_createAccount_error_${errorCode}`];
  }
  const errorMessage = error && error.get('errorMessage');
  return errorMessage
    ? // eslint-disable-next-line dot-notation
      error?.errorMessage?.['_error'] ||
        getLabelWithDefaultValue(dynamicAccountLabels, 'lbl_createAccount_error')
    : '';
});
